// eslint-disable-next-line import/prefer-default-export
export const addWordBreaks = (text: string): string => {
  if (!text) {
    return '';
  }
  return text.replace(/(\w\/)(?=\w)/, '$1\u200b');
};
